import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=0f2c6da0&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=0f2c6da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c6da0",
  null
  
)

export default component.exports